import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { LogGroup, Size, CreateElement, Scale } from "../../../../MyHelpers";
import { ImageResource } from "../../../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../../ResourceManager/SpriteResource";
import { Settings, JackpotDisplayType } from "../../../../Settings";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { CanvasSprite } from "../../../Sprite/CanvasSprite";
import { GameTitleJackpotDisplaySlide } from "./GameTitleJackpotDisplaySlide";
import { Slide, SlideFactory2Params } from "./Slide";

export class GameTitleJackpotDisplaySlide1Screen extends GameTitleJackpotDisplaySlide {



    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize:Size) {
        super(initData, p , viewSize) ;
        

        this.view = CreateElement("div", {
            classes: ["GameTitleJackpotDisplaySlide1Screen", this.resid.Scope()],
            style: {
                position: "absolute",
                height: Scale.Hpx(180),
                width: Scale.Wpx(900),
            }
        });

       //this.CreatePath();
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //resourceManager.Add(new PixiSpriteResource(this.path + "title_sprite2", ResourceIdentifier.Global.Add(this.initData.Name + "titlegame").Add("GameTitleSlider"), true, this.logGroup.Add("GameTitleSlider"), true));
        this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/JackpotsResources-Slider/"+Settings.JackpotDisplayType+"/titleJackpotDisplayImg.png";
        resourceManager.AddGlobal(new ImageResource( this.jackpot,ResourceIdentifier.Global.Add("titleJackpotDisplaySlider-"+Settings.JackpotDisplayType).Scope()));
    }

    public JackpotTitleImg : HTMLElement;

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.JackpotTitleImg = document.createElement("div");
		this.JackpotTitleImg.setAttribute("class", "JackpotTitleImg");
		this.JackpotTitleImg.classList.add(this.resid.ScopedResourceName("JackpotTitleImg"));
		this.JackpotTitleImg.style.position = "relative";
		//this.JackpotTitleImg.style.bottom = Scale.Ypx(0);
		//this.JackpotTitleImg.style.right = Scale.Xpx(0);
		this.JackpotTitleImg.style.width = "100%";
		this.JackpotTitleImg.style.height ="100%";
        this.JackpotTitleImg.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add("titleJackpotDisplaySlider-"+Settings.JackpotDisplayType)).CssBackground();
		this.JackpotTitleImg.style.backgroundPosition = "center";
		this.JackpotTitleImg.style.backgroundRepeat = "no-repeat";
		this.JackpotTitleImg.style.backgroundSize = "contain";
		this.view.appendChild(this.JackpotTitleImg);
    }
    public override View(): HTMLElement
	{
        return this.view;
	}
	
	public override Update()
	{
       
	}
	
	public override Start()
	{
        
    }

	public override Stop()
	{
      
    }
}
